import { render, staticRenderFns } from "./BaoKimConfig.vue?vue&type=template&id=bef36238&"
import script from "./BaoKimConfig.vue?vue&type=script&lang=js&"
export * from "./BaoKimConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports